<template>
  <div>
    <div style="margin-bottom: 32px; margin-top: -8px">
      <div class="content-input">
        <div class="content-input-item">
          <label>内容：</label>
          <el-select v-model="type" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in typeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <SearchComponents :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
        </div>
        <div class="content-input-item">
          <el-button type="primary" @click="getPage"> 查询 </el-button>
        </div>
      </div>
    </div>
    <div>
      <el-table
          ref="multipleTableRef"
          :data="pageDataList"
          style="width: 100%"
          border
          v-loading="listLoading"
      >
        <el-table-column property="createTime" label="时间"/>
        <el-table-column property="" label="用户信息" width="340">
          <template #default="scope">
            <UserInfoList :row="scope.row" showList="name,phone,uid"/>
          </template>
        </el-table-column>
            <el-table-column property="" label="头像">
              <template #default="scope">
                <el-image style="width: 80px; height: 80px" :src="scope.row.headImg.smallHeadImg" @click="showImg(scope.row.headImg.headImg)" class="cursor"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
              </template>
            </el-table-column>
        <el-table-column property="content" label="是否已发送">
          <template #default="scope">
            <p>{{scope.row.type == 1?'IM内容：':scope.row.type == 2?'图片/视频':scope.row.type == 3?'语音':scope.row.type == 4?'纸条内容：': ''}}{{scope.row.content}}</p>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import {getChatViolationUserPageList } from '@/api/url'
import { getFormData } from '@/api/api'
import ImgViewer from '../../../../assets/js/imageViewer'
import DatePickerRange from '@/components/DatePickerRange'
import SearchComponents from '@/components/SearchComponents'

export default {
  name: "InviteDetailDialog",
  components: { DatePickerRange, SearchComponents },
  props: {
    value: Object
  },
  data() {
    return {
      userId: this.value.id,

      //内容
      typeArray: [
        {label: '不限', value: -1},
        {label: 'IM内容', value: 1},
        {label: '图片/视频', value: 2},
        {label: '语音', value: 3},
        {label: '纸条内容', value: 4},
      ],
      type: -1,

      //时间
      startTime: '',
      endTime: '',


      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,

    }
  },
  methods: {
    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },
    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },


    getPage() {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['id'] = this.userId;
      param['type'] = this.type;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getChatViolationUserPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    showImg(url) {
      let imgList = []
      imgList.push(url)
      ImgViewer.open({
        imgList
      })
    },

    //语音
    pauseOther(index) {
      let audioDom= this.$refs['audio'+ index]
      audioDom.play();
      const audios = document.getElementsByTagName('audio');
      [].forEach.call(audios, function (i) {
        if(i !== audioDom) {
          i.pause();
          i.currentTime = 0;
        }
      })
    },


  },
  mounted() {
    this.getPage();
  }
}
</script>

<style scoped>

</style>
